'use client';

import React from 'react';
import { SliceComponentProps } from '@prismicio/react';
import { Card } from './Card';
import classNames from 'classnames';
import 'swiper/css';
import 'swiper/css/pagination';
import styles from './reasons-to-choose.module.scss';
import { Button } from '@get-mosh/msh-shared';
import EventNames from 'src/analytics/EventNames';
import { trackClick } from 'src/analytics/Events';
import Heading from 'src/components/Heading/Heading';
import CarouselGeneric from 'src/components/Carousel/CarouselGeneric';
import { Content } from '@prismicio/client';
import { Vertical } from 'src/constants/Verticals';

type ReasonsToChooseProps =
    SliceComponentProps<Content.ReasonsToChooseSlice> & {
        context: { pageType: string };
    };

const ReasonsToChoose = ({ slice, context }: ReasonsToChooseProps) => {
    const gridColsMap = {
        1: 'sm:grid-cols-1',
        2: 'sm:grid-cols-2',
        3: 'sm:grid-cols-3',
        4: 'sm:grid-cols-4',
        5: 'sm:grid-cols-3',
        6: 'sm:grid-cols-3',
    };
    const gridColsDesktop =
        gridColsMap[slice?.items?.length as keyof typeof gridColsMap] ??
        'sm:grid-cols-4';

    const backgroundColor = 'bg-green-light';

    return (
        <section className={classNames('py-10 md:py-20', backgroundColor)}>
            <div className="container flex flex-col">
                {slice?.primary?.title && (
                    <Heading
                        className={styles['section-title']}
                        tag="h"
                        level="h2"
                    >
                        {slice.primary.title}
                    </Heading>
                )}
                {slice?.items?.length > 0 && (
                    <>
                        <div className="block xl:hidden">
                            <CarouselGeneric>
                                {slice.items.map((item, i) => (
                                    <Card key={i} item={item} />
                                ))}
                            </CarouselGeneric>
                        </div>
                        <div
                            className={classNames(
                                'hidden gap-5 xl:grid',
                                gridColsDesktop,
                            )}
                        >
                            {slice.items.map((item, i) => (
                                <Card item={item} key={i} />
                            ))}
                        </div>
                    </>
                )}
                <span className="mx-auto mt-3 xl:mt-14">
                    <Button
                        text={slice.primary.link_label ?? ''}
                        as="a"
                        href={slice.primary.link_path ?? ''}
                        onClick={() => {
                            trackClick(EventNames.BUTTON_CLICKED, {
                                page_type: context.pageType,
                                vertical: slice.primary.vertical as Vertical,
                                label: slice.primary.link_label ?? '',
                                link: slice.primary.link_path ?? '',
                                variation: slice.variation,
                                location: slice.slice_type,
                            });
                        }}
                    />
                </span>
            </div>
        </section>
    );
};

export default ReasonsToChoose;
